import {getDaysText} from "../../utils/common";
// @ts-ignore
import {priorityClasses, priorityColorClass} from "../../utils/consts";
import {FlatpickrFn, Instance} from "flatpickr/dist/types/instance";

export class AbstractItem {
  item: HTMLElement;
  type: string;
  userType: string;
  openElement: HTMLElement;
  picker: Instance;
  id = ``;
  callback: {
    dateInputChange?: (date: string, formattedDate: string) => void;
    priorityInputChange?: (evt: Event) => void;
    openDeadlineInfoButtonClick?: (evt: Event) => void;
    changeDayModalClick?: (evt: Event) => void;
    openDatePickerButtonClick?: (evt: Event) => void;
    windowClick?: (evt: Event) => void;
    closeTaskElementClick?: () => void;
    openCloseModalClick?: () => void;
    closeModalElementClick?: (evt: Event) => void;
  } = {};
  priorityValue: string;
  deadlineValue: string | undefined;
  priorityInputsElements: NodeListOf<HTMLElement>;
  priorityHiddenInputsElements: NodeListOf<HTMLInputElement>;
  priorityColorsElements: NodeListOf<HTMLElement>;
  flatpickr: FlatpickrFn;

  constructor(item: HTMLElement, flatpickr: FlatpickrFn, type: string) {
    this.item = item;
    this.id = this.item.dataset.id!;
    this.flatpickr = flatpickr;
    this.openElement = this.item.querySelector(`.js-deadline-open`)!;
    this.priorityInputsElements = this.item.querySelectorAll(`.js-priority-input`);
    this.priorityHiddenInputsElements = this.item.querySelectorAll(`.js-priority-h-input`);
    this.priorityColorsElements = this.item.querySelectorAll(`.js-priority-color`);

    this.type = type;
    this.userType = this.item.dataset.userType!;
    this.priorityValue = this.getDefaultPriorityValue();

    this.watchDeadlineInfoClickHandler = this.watchDeadlineInfoClickHandler.bind(this);
    this.watchDateInputChangeHandler = this.watchDateInputChangeHandler.bind(this);
    this.watchPriorityInputChangeHandler = this.watchPriorityInputChangeHandler.bind(this);
  }

  init() {
    let postfix = ``;

    if (this.type === `today`) {
      postfix = `-1`;
    } else if (this.type === `favorite`) {
      postfix = `-2`;
    } else if (this.type === `sub-task`) {
      postfix = `-3`;
    }

    this.picker = this.flatpickr(`.js-deadline-input-${this.id}${postfix}`, {
      altFormat: "D, j M",
      dateFormat: "Y-m-d",
      minDate: "today",
      monthSelectorType: "static",
      static: false,
      disableMobile: true,
    }) as Instance;

    const deadlineElement: HTMLInputElement | null = this.item.querySelector(
      `.js-deadline-input-${this.id}${postfix}`);
    this.deadlineValue = deadlineElement ? deadlineElement.value : undefined;

    if (this.userType === `admin`) {
    }
  }

  getDefaultPriorityValue() {
    if (this.priorityHiddenInputsElements.length) {
      return this.priorityHiddenInputsElements[0].value;
    }

    return `1`;
  }

  getType() {
    return this.type;
  }

  getCurrentPriorityValue(): string {
    return this.priorityValue;
  }

  getCurrentDeadlineValue() {
    return this.deadlineValue;
  }

  openDatePicker() {
    this.picker.open();
  }

  destroyDatePicker() {
    this.picker.destroy();
  }

  setDateToDeadline(days) {
    this.openElement.textContent = getDaysText(days);
  }

  setCurrentPriorityValue(priority) {
    this.priorityValue = priority;
  }

  setCurrentDeadlineValue(date) {
    this.deadlineValue = date ? date : `Без срока`;
  }

  setPriority(priority) {
    this.priorityInputsElements.forEach((input) => (input.textContent = priority));

    if (this.priorityValue) {
      this.setCurrentPriorityValue(priority);
    }

    if (this.priorityHiddenInputsElements.length) {
      this.priorityHiddenInputsElements.forEach((input) => (input.value = priority));
    }

    this.priorityColorsElements.forEach((element) => {
      const currentColorClass = priorityClasses.find((priorityClass) => element.classList.contains(priorityClass))!;

      element.classList.remove(currentColorClass);
      element.classList.add(priorityColorClass[priority]);
    });
  }

  clearCalendarFocus() {
    this.item.tabIndex = 0;
    this.item.focus({preventScroll: true});
    this.item.removeAttribute(`tabIndex`);
    this.item.blur();
  }

  getId() {
    return this.id;
  }

  getItem() {
    return this.item;
  }

  getElement() {
    return this.item.cloneNode(true);
  }

  removeElement() {
    this.item.remove();
  }

  watchPriorityInputChangeHandler(evt: Event) {
    this.callback.priorityInputChange && this.callback.priorityInputChange(evt);
  }

  watchDateInputChangeHandler(date: string, formattedDate: string) {
    if (date !== this.deadlineValue) {
      this.callback.dateInputChange && this.callback.dateInputChange(date, formattedDate);
    }
    this.clearCalendarFocus();
  }

  watchDeadlineInfoClickHandler(evt: Event) {
    this.callback.openDeadlineInfoButtonClick && this.callback.openDeadlineInfoButtonClick(evt);
  }

  setPriorityInputChangeHandler(callback: (evt: Event) => void) {
    this.callback.priorityInputChange = callback;
    if (this.userType === `admin`) {
      this.priorityHiddenInputsElements.forEach(
        (input) => input.addEventListener(`change`, this.watchPriorityInputChangeHandler));
    }
  }

  setDateInputChangeHandler(callback: (date: string, formattedDate: string) => void) {
    this.callback.dateInputChange = callback;
    // TODO: отрефакторить проверку на существование элемента в другом месте
    // if (this.userType === `admin` && this.openElement) {
    if (this.openElement) {
      const inputChangeHandler = (date: string, formattedDate: string) => {
        this.watchDateInputChangeHandler(date, formattedDate);
      };

      this.picker.config.onChange.push(function(selectedDates, dateStr, instance) {
        inputChangeHandler(dateStr, dateStr ? instance.formatDate(new Date(dateStr), "d.m.Y") : "0.0.0");
      });
    }
  }

  setOpenDeadlineInfoClickHandler(callback: (evt: Event) => void) {
    this.callback.openDeadlineInfoButtonClick = callback;

    // if (this.userType === `admin` && this.openElement) {
    if (this.openElement) {
      this.openElement.addEventListener(`click`, this.watchDeadlineInfoClickHandler);
    }
  }
}
